import { render } from "./ProveedorPrediosIndex.vue?vue&type=template&id=3784e22f"
import script from "./ProveedorPrediosIndex.vue?vue&type=script&lang=js"
export * from "./ProveedorPrediosIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/cruds/ProveedorPrediosIndex.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3784e22f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3784e22f', __exports__)) {
    api.reload('3784e22f', __exports__)
  }
  
  module.hot.accept("./ProveedorPrediosIndex.vue?vue&type=template&id=3784e22f", () => {
    api.rerender('3784e22f', render)
  })

}


export default __exports__